// Modules
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Creatable from "react-select/creatable";
// Helpers
import { COMPUTER, GAME_SPEED_READING, HANDWRITING } from "./helpers/constants";
import { createGame } from "./helpers/actions";
// Syles
import "./css/App.css";

const DEFAULT_WORDS = ["Sonne", "ganz klein"];

function App() {
    const intl = useIntl();
    const [disableButton, setDisableButton] = useState(false);
    const [displayDuration, setDisplayDuration] = useState("1.0");
    const [font, setFont] = useState(COMPUTER);
    const [words, setWords] = useState(DEFAULT_WORDS.map(word => ({ label: word, value: word })));

    const handleOnSubmit = event => {
        event.preventDefault();

        if (!displayDuration || !font || !words || words.length === 0) {
            return;
        }

        const data = {
            type: GAME_SPEED_READING,
            display_duration: isNaN(displayDuration) ? undefined : Number.parseFloat(displayDuration),
            font,
            words: words?.map(word => word.value?.trim())
        };

        setDisableButton(true);
        createGame({
            data,
            successCb: ({ id }) => {
                window.open(`${process.env.REACT_APP_GAME_URL}?id=${id}`, "_self");
            },
            errorCb: () => {
                setDisableButton(false);

                setTimeout(() => {
                    // eslint-disable-next-line no-alert
                    alert(intl.formatMessage({ id: "error-creating-game" }));
                }, 200);
            }
        });
    };

    const handleSetDisplayDuration = event => {
        const value = event?.target?.value;

        if (!value || (value >= 0 && value <= 60)) {
            setDisplayDuration(value);
        }
    };

    const handleSetFont = event => {
        const value = event?.target?.value;

        setFont(value);
    };

    const handleSetWords = newValue => {
        setWords(newValue);
    };

    const handleFormKeyDown = event => {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    };

    return (
        <>
            <div className="App">
                <form onKeyDown={handleFormKeyDown} onSubmit={handleOnSubmit}>
                    <div className="mb-xl">
                        <h3 className="header mb-md">
                            <FormattedMessage id="settings" />
                        </h3>
                        <div className="field mb-md">
                            <label className="semi-bold mb-xs" htmlFor="displayDuration">
                                <FormattedMessage id="display-duration-seconds" />
                            </label>
                            <input
                                className="input-number"
                                id="displayDuration"
                                max="60.0"
                                min="0.1"
                                name="displayDuration"
                                onChange={handleSetDisplayDuration}
                                step="0.1"
                                type="number"
                                value={displayDuration}
                            />
                            {(!displayDuration || displayDuration.length === 0 || displayDuration === "0") && (
                                <span className="text-error error text-error-input">
                                    <FormattedMessage id="error-required-field" />
                                </span>
                            )}
                        </div>
                        <div className="field">
                            <label className="semi-bold mb-xs" htmlFor="font">
                                <FormattedMessage id="font" />
                            </label>
                            <select
                                className="select-font"
                                name="font"
                                id="font"
                                required
                                value={font}
                                onChange={handleSetFont}
                            >
                                <option className="text" value={COMPUTER}>
                                    <FormattedMessage id={COMPUTER} />
                                </option>
                                <option className="text" value={HANDWRITING}>
                                    <FormattedMessage id={HANDWRITING} />
                                </option>
                            </select>
                        </div>
                    </div>
                    <div className="mb-xl">
                        <h3 className="header mb-md">
                            <FormattedMessage id="words-list" />
                        </h3>
                        <Creatable
                            className="field words"
                            components={{ DropdownIndicator: null }}
                            defaultValue={words}
                            formatCreateLabel={inputValue => inputValue}
                            isClearable
                            isMulti
                            name="words"
                            noOptionsMessage={() => null}
                            onChange={handleSetWords}
                            placeholder=""
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    danger: "#c51d34",
                                    primary: "#314f6f"
                                }
                            })}
                        />
                        <div className="helper-text mt-xxxs">
                            {/* <FormattedMessage id="words-list-add-word-description" /> */}
                            Du kannst Wörter hinzufügen, indem du das Wort schreibst und "Enter" drückst
                        </div>
                        {(!words || words.length === 0) && (
                            <div className="text-error error">
                                <FormattedMessage id="error-required-field" />
                            </div>
                        )}
                    </div>
                    <button className="submit-button" disabled={disableButton} type="submit">
                        <FormattedMessage id="create-exercise" />
                    </button>
                </form>
            </div>
        </>
    );
}

export default App;
